import { useCallback, useEffect, useState } from "react";
import { TicketThread } from "@/components/TicketThread";
import { TicketList } from "@/pages/SupportPage";
import { api } from "@/lib/api";

export default function AdminSupport({ onChange }) {
  const [status, setStatus] = useState("open");
  const [items, setItems] = useState([]);
  const [active, setActive] = useState(null);
  const load = useCallback(() => {
    api.get("/admin/support", { params: { status } }).then((r) => setItems(r.data)).catch(() => {});
    onChange?.();
  }, [status, onChange]);
  useEffect(() => { load(); }, [load]);

  return (
    <div className="grid lg:grid-cols-[320px_1fr] gap-4">
      <div className={`rounded-2xl bg-white border border-[#d1e7dd] overflow-hidden ${active ? "hidden lg:block" : ""}`}>
        <div className="grid grid-cols-2 p-2 gap-1 border-b border-[#d1e7dd]">
          {[["open", "Открытые"], ["closed", "Закрытые"]].map(([k, l]) => (
            <button key={k} onClick={() => { setStatus(k); setActive(null); }} data-testid={`admin-support-filter-${k}`}
              className={`py-2 rounded-full text-sm font-semibold ${status === k ? "bg-[#1f5f42] text-white" : "text-[#1f5f42]"}`}>{l}</button>
          ))}
        </div>
        <div className="max-h-[560px] overflow-y-auto scrollbar-thin" data-testid="admin-tickets-list">
          <TicketList items={items} active={active} onSelect={setActive} />
        </div>
      </div>
      <div className={`rounded-2xl bg-white border border-[#d1e7dd] overflow-hidden min-h-[300px] ${active ? "" : "hidden lg:block"}`}>
        {active && <button onClick={() => setActive(null)} className="lg:hidden px-5 pt-4 text-sm font-semibold text-[#2e7d56]" data-testid="admin-ticket-back-button">← К списку</button>}
        {active ? <TicketThread key={active} ticketId={active} staff onChange={load} /> : <p className="p-10 text-center text-sm text-[#6b8a7b]">Выберите обращение слева</p>}
      </div>
    </div>
  );
}
